export default [
  {
    label: '坦程',
    value: '坦程',
  }
]



// WEBPACK FOOTER //
// ./src/utils/channelOptions.js